import { createRouter, createWebHistory } from 'vue-router'

import Ecommerce from '../views/Ecommerce/Ecommerce'
import Signin from '../views/Ecommerce/Signin'
import Signup from '../views/Ecommerce/Signup'
import amazonCart from '../views/Ecommerce/amazonCart'
import Shopping from '../views/Ecommerce/Shopping'
import Glowup from '../views/Ecommerce/Glowup'
import CustomerLoved from '../views/Ecommerce/CustomerLoved'
import UpgradeGame from '../views/Ecommerce/UpgradeGame'
import DelightfulDeal from '../views/Ecommerce/DelightfulDeal'
import SmallGifts from '../views/Ecommerce/SmallGifts'
import ShopStorage from '../views/Ecommerce/ShopStorage'
import ShopToys from '../views/Ecommerce/ShopToys'
import SweetHome from '../views/Ecommerce/SweetHome'
import Pc from '../views/Ecommerce/Pc'
import FunFor from '../views/Ecommerce/FunFor'
import HomeDecore from '../views/Ecommerce/HomeDecore'
import ShopeHoilday from '../views/Ecommerce/ShopeHoilday'
import General from '../views/Ecommerce/General'
import Desktop from '../views/Ecommerce/Desktop'
import Laptop from '../views/Ecommerce/Laptop'
import HardDrive from '../views/Ecommerce/HardDrive'
import PCAccessories from '../views/Ecommerce/PCAccessories'
import Womens from '../views/Ecommerce/Womens'
import Mens from '../views/Ecommerce/Mens'
import Girls from '../views/Ecommerce/Girls'
import Boys from '../views/Ecommerce/Boys'
import Kitchen from '../views/Ecommerce/Kitchen'
import HomeDecore2 from '../views/Ecommerce/HomeDecore2'
import Dining from '../views/Ecommerce/Dining'
import SmartHome from '../views/Ecommerce/SmartHome'
import Jewelry from '../views/Ecommerce/Jewelry'
import HandBag from '../views/Ecommerce/HandBag'
import FootWear from '../views/Ecommerce/FootWear'
import Beuty from '../views/Ecommerce/Beuty'
import Xbox from '../views/Ecommerce/Xbox'
import Nintendo from '../views/Ecommerce/Nintendo'
import VR from '../views/Ecommerce/VR'
import Ps5 from '../views/Ecommerce/Ps5'
import HairCare from '../views/Ecommerce/HairCare'
import Fragrances from '../views/Ecommerce/Fragrances'
import Makeup from '../views/Ecommerce/Makeup'
import SkinCare from '../views/Ecommerce/SkinCare'
import WomensClothing from '../views/Ecommerce/WomensClothing'
import WomensShoes from '../views/Ecommerce/WomensShoes'
import MensClothing from '../views/Ecommerce/MensClothing'
import MensShoes from '../views/Ecommerce/MensShoes'
import Kitchenanddining from '../views/Ecommerce/Kitchenanddining'
import Furniture from '../views/Ecommerce/Furniture'
import Bedding from '../views/Ecommerce/Bedding'
import HomeImprovement from '../views/Ecommerce/HomeImprovement'
import Garden from '../views/Ecommerce/Garden'
import Decor from '../views/Ecommerce/Decor'
import Snak from '../views/Ecommerce/Snak'
import Toys from '../views/Ecommerce/Toys'
import Strolers from '../views/Ecommerce/Strolers'
import Car from '../views/Ecommerce/Car'
import Tab1 from '../views/Ecommerce/Tab1'
import Tab2 from '../views/Ecommerce/Tab2'
import Tab3 from '../views/Ecommerce/Tab3'
import Tab4 from '../views/Ecommerce/Tab4'
import DealsOnShoes from '../views/Ecommerce/DealsOnShoes'
import Apparel from '../views/Ecommerce/Apparel'
import Hats from '../views/Ecommerce/Hats'
import Action from '../views/Ecommerce/Action'
import Mugs from '../views/Ecommerce/Mugs'
import WomenShoes1 from '../views/Ecommerce/WomenShoes1'
import WomenShoes2 from '../views/Ecommerce/WomenShoes2'
import WomenShoes3 from '../views/Ecommerce/WomenShoes3'
import WomenShoes4 from '../views/Ecommerce/WomenShoes4'
import Homandkitches from '../views/Ecommerce/Homandkitches'
import Travel from '../views/Ecommerce/Travel'
import NewWay from '../views/Ecommerce/NewWay'
import Beauty from '../views/Ecommerce/Beauty'
import Homeandkitchen from '../views/Ecommerce/Homeandkitchen'
import Sports from '../views/Ecommerce/Sports'
import Electronics from '../views/Ecommerce/Electronics'
import Outdoor from '../views/Ecommerce/Outdoor'
import Pet from '../views/Ecommerce/Pet'
import Book1 from '../views/Ecommerce/Book1'
import Book2 from '../views/Ecommerce/Book2'
import Book3 from '../views/Ecommerce/Book3'
import Login from '../views/Ecommerce/Login'
import UserProfile from '../views/Ecommerce/UserProfile'
import PostProduct from '../views/Ecommerce/PostProduct'
import ProductDetails from '../views/Ecommerce/ProductDetails'
import Products from '../views/Ecommerce/Products'
import BlueDress from '../views/Ecommerce/BlueDress'



const routes = [
  {
    path: '/',
    name: 'Ecommerce',
    component: Ecommerce
  },
  {
    path: '/Signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/Signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/amazonCart',
    name: 'amazonCart',
    component: amazonCart,
    meta: {
      title: 'amazonCart'
    }
  },
  {
    path: '/Shopping',
    name: 'Shopping',
    component: Shopping,
    meta: {
      title: 'Shopping'
    }
  },
  {
    path: '/Glowup',
    name: 'Glowup',
    component: Glowup,
    meta: {
      title: 'Glowup'
    }
  },
  {
    path: '/CustomerLoved',
    name: 'CustomerLoved',
    component: CustomerLoved,
    meta: {
      title: 'CustomerLoved'
    }
  },
  {
    path: '/UpgradeGame',
    name: 'UpgradeGame',
    component: UpgradeGame,
    meta: {
      title: 'UpgradeGame'
    }
  },
  {
    path: '/DelightfulDeal',
    name: 'DelightfulDeal',
    component: DelightfulDeal,
    meta: {
      title: 'DelightfulDeal'
    }
  },
  {
    path: '/SmallGifts',
    name: 'SmallGifts',
    component: SmallGifts,
    meta: {
      title: 'SmallGifts'
    }
  },
  {
    path: '/ShopStorage',
    name: 'ShopStorage',
    component: ShopStorage,
    meta: {
      title: 'ShopStorage'
    }
  },
  {
    path: '/ShopToys',
    name: 'ShopToys',
    component: ShopToys,
    meta: {
      title: 'ShopToys'
    }
  },
  {
    path: '/SweetHome',
    name: 'SweetHome',
    component: SweetHome,
    meta: {
      title: 'SweetHome'
    }
  },
  {
    path: '/Pc',
    name: 'Pc',
    component: Pc,
    meta: {
      title: 'Pc'
    }
  },
  {
    path: '/FunFor',
    name: 'FunFor',
    component: FunFor,
    meta: {
      title: 'FunFor'
    }
  },
  {
    path: '/HomeDecore',
    name: 'HomeDecore',
    component: HomeDecore,
    meta: {
      title: 'HomeDecore'
    }
  },
  {
    path: '/ShopeHoilday',
    name: 'ShopeHoilday',
    component: ShopeHoilday,
    meta: {
      title: 'ShopeHoilday'
    }
  },
  {
    path: '/General',
    name: 'General',
    component: General,
    meta: {
      title: 'General'
    }
  },
  {
    path: '/Desktop',
    name: 'Desktop',
    component: Desktop,
    meta: {
      title: 'Desktop'
    }
  },
  {
    path: '/Laptop',
    name: 'Laptop',
    component: Laptop,
    meta: {
      title: 'Laptop'
    }

  },
  {
    path: '/HardDrive',
    name: 'HardDrive',
    component: HardDrive,
    meta: {
      title: 'HardDrive'
    }
  },
  {
    path: '/PCAccessories',
    name: 'PCAccessories',
    component: PCAccessories,
    meta: {
      title: 'PCAccessories'
    }
  },
  {
    path: '/Womens',
    name: 'Womens',
    component: Womens,
    meta: {
      title: 'Womens'
    }

  },
  {
    path: '/Mens',
    name: 'Mens',
    component: Mens,
    meta: {
      title: 'Mens'
    }

  },
  {
    path: '/Girls',
    name: 'Girls',
    component: Girls,
    meta: {
      title: 'Girls'
    }
  },
  {
    path: '/Boys',
    name: 'Boys',
    component: Boys,
    meta: {
      title: 'Boys'
    }
  },
  {
    path: '/Kitchen',
    name: 'Kitchen',
    component: Kitchen,
    meta: {
      title: 'Kitchen'
    }

  },
  {
    path: '/HomeDecore2',
    name: 'HomeDecore2',
    component: HomeDecore2,
    meta: {
      title: 'HomeDecore2'
    }
  },
  {
    path: '/Dining',
    name: 'Dining',
    component: Dining,
    meta: {
      title: 'Dining'
    }
  },
  {
    path: '/SmartHome',
    name: 'SmartHome',
    component: SmartHome,
    meta: {
      title: 'SmartHome'
    }
  },
  {
    path: '/Jewelry',
    name: 'Jewelry',
    component: Jewelry,
    meta: {
      title: 'Jewelry'
    }
  },
  {
    path: '/HandBag',
    name: 'HandBag',
    component: HandBag,
    meta: {
      title: 'HandBag'
    }
  },
  {
    path: '/FootWear',
    name: 'FootWear',
    component: FootWear,
    meta: {
      title: 'FootWear'
    }
  },
  {
    path: '/Beuty',
    name: 'Beuty',
    component: Beuty,
    meta: {
      title: 'Beuty'
    }
  },
  {
    path: '/Xbox',
    name: 'Xbox',
    component: Xbox,
    meta: {
      title: 'Xbox'
    }

  },
  {
    path: '/Nintendo',
    name: 'Nintendo',
    component: Nintendo,
    meta: {
      title: 'Nintendo'
    }
  },
  {
    path: '/VR',
    name: 'VR',
    component: VR,
    meta: {
      title: 'VR'
    }
  },
  {
    path: '/Ps5',
    name: 'Ps5',
    component: Ps5,
    meta: {
      title: 'Ps5'
    }
  },
  {
    path: '/HairCare',
    name: 'HairCare',
    component: HairCare,
    meta: {
      title: 'HairCare'
    }
  },
  {
    path: '/Fragrances',
    name: 'Fragrances',
    component: Fragrances,
    meta: {
      title: 'Fragrances'
    }
  },
  {
    path: '/Makeup',
    name: 'Makeup',
    component: Makeup,
    meta: {
      title: 'Makeup'
    }
  },
  {
    path: '/SkinCare',
    name: 'SkinCare',
    component: SkinCare,
    meta: {
      title: 'SkinCare'
    }
  },
  {
    path: '/WomensClothing',
    name: 'WomensClothing',
    component: WomensClothing,
    meta: {
      title: 'WomensClothing'
    }
  },
  {
    path: '/WomensShoes',
    name: 'WomensShoes',
    component: WomensShoes,
    meta: {
      title: 'WomensShoes'
    }
  },
  {
    path: '/MensClothing',
    name: 'MensClothing',
    component: MensClothing,
    meta: {
      title: 'MensClothing'
    }
  },
  {
    path: '/MensShoes',
    name: 'MensShoes',
    component: MensShoes,
    meta: {
      title: 'MensShoes'
    }
  },
  {
    path: '/Kitchenanddining',
    name: 'Kitchenanddining',
    component: Kitchenanddining,
    meta: {
      title: 'Kitchenanddining'
    }
  },
  {
    path: '/Furniture',
    name: 'Furniture',
    component: Furniture,
    meta: {
      title: 'Furniture'
    }
  },
  {
    path: '/Bedding',
    name: 'Bedding',
    component: Bedding,
    meta: {
      title: 'Bedding'
    }
  },
  {
    path: '/HomeImprovement',
    name: 'HomeImprovement',
    component: HomeImprovement,
    meta: {
      title: 'HomeImprovement'
    }
  },
  {
    path: '/Garden',
    name: 'Garden',
    component: Garden,
    meta: {
      title: 'Garden'
    }
  },
  {
    path: '/Decor',
    name: 'Decor',
    component: Decor,
    meta: {
      title: 'Decor'
    }
  },
  {
    path: '/Snak',
    name: 'Snak',
    component: Snak,
    meta: {
      title: 'Snak'
    }
  },
  {
    path: '/Toys',
    name: 'Toys',
    component: Toys,
    meta: {
      title: 'Toys'
    }
  },
  {
    path: '/Strolers',
    name: 'Strolers',
    component: Strolers,
    meta: {
      title: 'Strolers'
    }
  },
  {
    path: '/Car',
    name: 'Car',
    component: Car,
    meta: {
      title: 'Car'
    }
  },
  {
    path: '/Tab1',
    name: 'Tab1',
    component: Tab1,
    meta: {
      title: 'Tab1'
    }
  },
  {
    path: '/Tab2',
    name: 'Tab2',
    component: Tab2,
    meta: {
      title: 'Tab2'
    }
  },
  {
    path: '/Tab3',
    name: 'Tab3',
    component: Tab3,
    meta: {
      title: 'Tab3'
    }
  },
  {
    path: '/Tab4',
    name: 'Tab4',
    component: Tab4,
    meta: {
      title: 'Tab4'
    }
  },
  {
    path: '/DealsOnShoes',
    name: 'DealsOnShoes',
    component: DealsOnShoes,
    meta: {
      title: 'DealsOnShoes'
    }
  },
  {
    path: '/Apparel',
    name: 'Apparel',
    component: Apparel,
    meta: {
      title: 'Apparel'
    }
  },
  {
    path: '/Hats',
    name: 'Hats',
    component: Hats,
    meta: {
      title: 'Hats'
    }
  },
  {
    path: '/Action',
    name: 'Action',
    component: Action,
    meta: {
      title: 'Action'
    }
  },
  {
    path: '/Mugs',
    name: 'Mugs',
    component: Mugs,
    meta: {
      title: 'Mugs'
    }
  },
  {
    path: '/WomenShoes1',
    name: 'WomenShoes1',
    component: WomenShoes1,
    meta: {
      title: 'WomenShoes1'
    }
  },
  {
    path: '/WomenShoes2',
    name: 'WomenShoes2',
    component: WomenShoes2,
    meta: {
      title: 'WomenShoes2'
    }
  },
  
  {
    path: '/WomenShoes3',
    name: 'WomenShoes3',
    component: WomenShoes3,
    meta: {
      title: 'WomenShoes3'
    }
  },
  
  {
    path: '/WomenShoes4',
    name: 'WomenShoes4',
    component: WomenShoes4,
    meta: {
      title: 'WomenShoes4'
    }
  },
  // {
  //   path: '/WomenShoes4',
  //   name: 'WomenShoes4',
  //   component: WomenShoes4,
  //   meta: {
  //     title: 'WomenShoes4'
  //   }
  // },
  {
    path: '/Homandkitches',
    name: 'Homandkitches',
    component: Homandkitches,
    meta: {
      title: 'Homandkitches'
    }
  },
  {
    path: '/Travel',
    name: 'Travel',
    component: Travel,
    meta: {
      title: 'Travel'
    }
  },
  {
    path: '/NewWay',
    name: 'NewWay',
    component: NewWay,
    meta: {
      title: 'NewWay'
    }
  },
  {
    path: '/Beauty',
    name: 'Beauty',
    component: Beauty,
    meta: {
      title: 'Beauty'
    }
  },
  {
    path: '/Homeandkitchen',
    name: 'Homeandkitchen',
    component: Homeandkitchen,
    meta: {
      title: 'Homeandkitchen'
    }
    
  },
  {
    path: '/Sports',
    name: 'Sports',
    component: Sports,
    meta: {
      title: 'Sports'
    }
  },
  {
    path: '/Electronics',
    name: 'Electronics',
    component: Electronics,
    meta: {
      title: 'Electronics'
    }
  },
  {
    path: '/Outdoor',
    name: 'Outdoor',
    component: Outdoor,
    meta: {
      title: 'Outdoor'
    }
  },
  {
    path: '/Pet',
    name: 'Pet',
    component: Pet,
    meta: {
      title: 'Pet'
    }
  },
  {
    path: '/Book1',
    name: 'Book1',
    component: Book1,
    meta: {
      title: 'Book1'
    }
  },
  {
    path: '/Book2',
    name: 'Book2',
    component: Book2,
    meta: {
      title: 'Book2'
    }
  },
  {
    path: '/Book3',
    name: 'Book3',
    component: Book3,
    meta: {
      title: 'Book3'
    }

  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login'
    },

  },
  {
    path: '/UserProfile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      title: 'UserProfile'
    },

  },
  {
    path: '/PostProduct',
    name: 'PostProduct',
    component: PostProduct,
    meta: {
      title: 'PostProduct'
    },

  },
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    component: ProductDetails,
    meta: {
      title: 'ProductDetails'
    },

  },
  {
    path: '/Products',
    name: 'Products',
    component: Products,
    meta: {
      title: 'Products'
    },

  },
  {
    path: '/BlueDress',
    name: 'BlueDress',
    component: BlueDress,
    meta: {
      title: 'BlueDress'
    },

  },
  
  
  
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | Ecommerce`
  next()
})
export default router
